module.exports = __webpack_public_path__ + "img/footer.3fbb0f19.jpg";